import React from "react";
import poweredby from "../assets/poweredby.png";

export default function PoweredByLogo({
  className = "",
  alt = "Powered by Cphere",
  onClick,
  style,
  ...rest
}) {
  return (
    <img
      src={poweredby}
      alt={alt}
      className={`cphere-poweredby-header-logo ${className}`.trim()}
      onClick={onClick}
      style={style}
      {...rest}
    />
  );
}
